const recommendationContext = { type: 'OTHER' };
window.DY = window.DY || {};
window.DY.recommendationContext = recommendationContext;
